/* src/app/email-campaign/email-campaign-google-button/email-campaign-google-button.component.scss */
/*# sourceMappingURL=email-campaign-google-button.component-GLK3XPT2.css.map */
